import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

function TechnicalWindow() {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigateToPage = (screen, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === `/${screen}`) === -1) {
      updateTabs.push({
        navTo: `/${screen}`,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: `/${screen}`,
    });
  };

  return (
    <div className='tabs-container'>
      <div className='tBillPanel custom-check'>
        <div className='panel tBillPanel-space pb-0'>
          <CustomSeparator parent1='System' parent2='Technical Window' />
          <div className='row btn-wrapper mb-2'>
            <div className='mt-1 ml-4 hide-on-print'>
              <Button
                tabIndex={0}
                className='btn-success same-font-family frr-btn-width-17 mt-4'
                onClick={() =>
                  navigateToPage('onlineFixes', 'Process Online Fixes')
                }
              >
                Online Fixes
              </Button>
            </div>
            <div className='mt-1 ml-4 hide-on-print'>
              <Button
                tabIndex={0}
                className='btn-success same-font-family frr-btn-width-17 mt-4'
                onClick={() =>
                  navigateToPage('periodicBalanceRpt', 'Periodic Balance Rpt')
                }
              >
                Periodic Balance Report
              </Button>
            </div>
            <div className='mt-1 ml-4 hide-on-print'>
              <Button
                tabIndex={0}
                className='btn-success same-font-family frr-btn-width-17 mt-4'
                onClick={() =>
                  navigateToPage('transitionData', 'Transition Data')
                }
              >
                Transition Data
              </Button>
            </div>
            <div className='mt-1 ml-4 hide-on-print'>
              <Button
                tabIndex={0}
                className='btn-success same-font-family frr-btn-width-17 mt-4'
                onClick={() =>
                  navigateToPage(
                    'quarterlyMarketingData',
                    'Req Quarterly Marketing Data'
                  )
                }
              >
                Quarterly Marketing Data
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TechnicalWindow;
